import { shopifyRequest } from '.'

interface UpdateCartLinesVariables {
  cartId: string
  lines: any[]
}

const updateCartLines = async (variables: UpdateCartLinesVariables, silent = true) => {
  const result = await shopifyRequest(`
    mutation updateCartLines($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) {
        cart {
          id
          checkoutUrl
          lines(first: 10) {
            edges {
              node {
                id
                quantity
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    quantityAvailable
                    product {
                      id
                      title
                    }
                    image {
                      id
                      src
                    }
                    priceV2 {
                      amount
                      currencyCode
                    }
                  }
                }
                estimatedCost {
                  subtotalAmount {
                    amount
                    currencyCode
                  }
                  totalAmount {
                    amount
                    currencyCode
                  }
                }
                attributes {
                  key
                  value
                }
              }
            }
          }
          estimatedCost {
            subtotalAmount {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `, variables, silent)

  return result.cartLinesUpdate
}

export default updateCartLines